module.exports = {
  "goods":[
    {
      'id': 'a',
      'kind': '机器人',
      'child': [
        {
        'id': 'a-1',
        'name': '轨道巡检机器人',
        'path': './static/images/G301.png',
        'pathS': './static/images/G302.png',
        'model':'YNEN-9X G3',
        'useFor':'开关室巡检运维\n',
        'imgList':['./static/images/G301.png','./static/images/G303.png','./static/images/G304.png'],
        'overview':'<p style="line-height: 1.5em;">\n' +
          '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">YNEN-9X G3专为<ins>开关室巡检运维</ins>设计。</span>\n' +
          '</p>\n' +
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">目前配电房、开关室依赖于人工巡视作业。在高负荷期间和有特殊保供电要求时，须增加巡检频次。随着近年来电网飞速发展，生产人员不足和巡检工作量增加之间的矛盾日益突出。</span>\n' +
          '</p>\n' +
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);"><br/></span>\n' +
          '</p>\n' +
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(63, 63, 63);"></span><span style="font-family: 方正黑体_GBK; font-size: 16px; color: rgb(62, 62, 63);">配电站作为电网末端的关键节点，是智能电网建设的重要组成部分。由于配电站数量众多，依赖人员维护工作量巨大， 因此一般配电站很少会进行维护，直至发生事故才会到现场抢修，严重影响企事业单位、居民群众的正常生产生活秩 序；另外，由于配电站淹水、盗窃、失火等情况的不断发生，直接危害电网的安全运行。因此，提高对配电站的技术智 能监控、管理水平，确保其正常运行，对提高电网运行安全、供电可靠性有着重要意义。</span>\n' +
          '</p>\n' +
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(62, 62, 63);"><br/></span>\n' +
          '</p>\n' +
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-family: 方正黑体_GBK; font-size: 16px; color: rgb(62, 62, 63);">YNEN-9X G3高达640X510红外热成像高分辨率，可以提供更精细的红外图像，精准识别各连接点温度。采用视觉导航定位技术，具有”永不迷航“功能，能够按照运维指令，100%准确到达巡检目的地，执行巡检任务。</span>\n' +
          '</p>\n' +
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(62, 62, 63);"><br/></span>\n' +
          '</p>\n' +
          '<p style="line-height: 1.5em;">\n' +
          '    <strong><span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(62, 62, 63);">YNEN-9X G3轨道巡检机器人功能配置表：</span></strong><strong><span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);"></span></strong><strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(62, 62, 63);"></span></strong>\n' +
          '</p>\n' +
          '<p style="line-height: 1.5em;">\n' +
          '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(62, 62, 63);"></span></strong>\n' +
          '</p>'+
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(62, 62, 63);"><br/></span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <img style="width: 80%" src="./static/images/g3/g3-1.png"/>\n' +
          '</p>\n'+
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(62, 62, 63);"><br/></span>\n' +
          '</p>\n' +
          '<p style="line-height: 1.5em;">\n' +
          '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(62, 62, 63);">产品结构</span></strong>\n' +
          '</p>\n'+
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(62, 62, 63);"><br/></span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <img style="width: 80%" src="./static/images/g3/g3-2.png"/>\n' +
          '</p>\n'+
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(62, 62, 63);"><br/></span>\n' +
          '</p>\n' +
          '<p style="line-height: 1.5em;">\n' +
          '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(62, 62, 63);">产品优势</span></strong>\n' +
          '</p>\n'+
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(62, 62, 63);"><br/></span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <img style="width: 80%" src="./static/images/g3/g3-3.png"/>\n' +
          '</p>\n'
        ,
        'parameter':'<table data-sort="sortDisabled">\n' +
          '    <tbody>\n' +
          '        <tr class="firstRow">\n' +
          '            <td width="252" valign="middle" style="word-break: break-all;" rowspan="14" colspan="1" align="left">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">轨道巡检机器人</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">YNEN-9X G3</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">行走速度</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1m/s</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">自主导航定位精度</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±10mm</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">最小转弯半径</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥500mm</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">最大提升高度</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥1.5m</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">图像分辨率</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1920 x 1080P</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">可见光相机光学变焦倍数</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥20倍</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">云台性能</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">垂直范围0°- +97°</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">水平范围-180°- 180°</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">输入电源</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">AC220V±20%，50Hz</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">输出电源</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">DC24V（轨道有限供电）</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">巡航时间</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">不限</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">表计识别准确率</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥98%</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">故障预警准确率</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥90%</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">外形尺寸</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤313 x 323 x 1398mm</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">重量</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤30kg</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="middle" style="word-break: break-all;" rowspan="4" colspan="1" align="left">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">SF<sub>6</sub>气体泄漏监测</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">SF<sub style="white-space: normal;">6</sub><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px;">报警阈值</span></span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1000 x 10 - 6</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">准确度</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">＜5%</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">O<sub>2</sub>监测范围</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1.0-25%</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">准确度</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">＜5%</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="middle" style="word-break: break-all;" rowspan="2" colspan="1" align="left">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">环境温湿度监测<br/></span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">温度检测范围</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">-20℃-99℃</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">湿度检测范围</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0-99%RH</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="2" style="word-break: break-all;" align="left">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">臭氧监测</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">O<sub>3</sub>气体测量范围</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0-100ppm</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">分辨率</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0.1ppm</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="2" style="word-break: break-all;" align="left">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">噪声监测</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">噪声监测范围</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">30-120dB</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">噪声分辨率</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0.1dB</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="2" style="word-break: break-all;" align="left">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">有害气体监测</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">TVOC测量量程</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0-60000ppb</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">TVOC显示分辨率</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1ppb</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="2" style="word-break: break-all;" align="left">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">烟雾监测</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">报警方式</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">声/光</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">报警声压级</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥85dB/3m</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="3" style="word-break: break-all;" align="left">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">局部放电监测</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 12px;">（超声波）</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">中心频率</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">40kHz</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">测量灵敏度</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">-60dB</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">测量范围</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">-60dB~18dB</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '    </tbody>\n' +
          '</table>\n' +
          '<p>\n' +
          '    <br/>\n' +
          '</p>',
        'download':''
      },
        {
        'id': 'a-2',
        'name': '变电站巡检机器人',
        'path': './static/images/l2/tu-1.png',
        'pathS': './static/images/l2/tu-2.png',
        'model':'YNEN-9X L2',
        'useFor':'变电站日常运维',
        'imgList':['./static/images/l2/tu-1.png'],
        'overview':
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">YNEN-9X L2专为<ins>变电站运维</ins>设计。&nbsp;</span>\n' +
          '</p>\n' +
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">它独具高准确度定位技术，具有”永不迷航“功能，能够按照运维指令，100%准确到达巡检目的地，执行巡检任务。</span>\n' +
          '</p>\n' +
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);"><br/></span>\n' +
          '</p>\n' +
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(63, 63, 63);">高达640x510的红外成像分辨率，可以提供更精细的红外图像，精准识别各连接点温度。&nbsp;</span>\n' +
          '</p>\n' +
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">32倍光学变焦在AI支持下，可以精确巡检变电站内的设备细节：表计、开关位置、分合闸状态、指示灯。</span>\n' +
          '</p>\n' +
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(63, 63, 63);">支持升级的边缘计算功能，可以不断提供更高的智慧能力。</span>\n' +
          '</p>\n' +
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);"><br/></span>\n' +
          '</p>\n' +
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(63, 63, 63);">YNEN-9XL2，变电运维人员真正的伙伴。&nbsp;</span>\n' +
          '</p>\n' +
          '<p style="line-height: 1.5em;">\n' +
          '    <strong><span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">YNEN-9X L2开关室巡检机器人功能配置表：</span></strong><strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(62, 62, 63);"></span></strong>\n' +
          '</p>\n' +
          '<p style="line-height: 1.5em;">\n' +
          '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(62, 62, 63);"></span></strong>\n' +
          '</p>'+
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(62, 62, 63);"><br/></span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <img style="width: 80%" src="./static/images/l2/l2-2.png"/>\n' +
          '</p>\n'+
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(62, 62, 63);"><br/></span>\n' +
          '</p>\n' +
          '<p style="line-height: 1.5em;">\n' +
          '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(62, 62, 63);">产品结构</span></strong>\n' +
          '</p>\n'+
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(62, 62, 63);"><br/></span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <img style="width: 80%" src="./static/images/l2/L2P 巡检机器人-02.png"/>\n' +
          '</p>\n'+
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(62, 62, 63);"><br/></span>\n' +
          '</p>\n' +
          '<p style="line-height: 1.5em;">\n' +
          '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(62, 62, 63);">产品优势</span></strong>\n' +
          '</p>\n'+
          '<p style="line-height: 1.5em;">\n' +
          '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(62, 62, 63);"><br/></span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <img style="width: 80%" src="./static/images/l2/l2-3.png"/>\n' +
          '</p>\n',
        'parameter':'<table data-sort="sortDisabled">\n' +
          '    <tbody>\n' +
          '        <tr class="firstRow">\n' +
          '            <td width="252" valign="middle" style="word-break: break-all;" rowspan="15" colspan="1" align="left">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">变电站巡检机器人</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">导航定位误差</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤100mm</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">最大运动速度</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥1m/s<br/></span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">最小制动距离</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤0.5m</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">最小越障高度</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">50mm</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">最小涉水深度</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">100mm</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">爬坡能力</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥20°</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">最小转弯直径</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤本体长度</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">云台性能</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">垂直范围：-15°- 90°</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">水平范围：-180°- 180°</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">可见光分辨率</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1080P</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">光学变焦</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">30倍</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">仪表识别准确率</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">98%</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">红外测温准确度</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±2℃或±2%</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">红外测温范围</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">-20℃~200℃</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">电池续航能力</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥8h</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">电池充满时间</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤5h</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="4" style="word-break: break-all;" align="left">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">温湿度监测模块</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">温度检测范围</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">-20℃-99℃</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">检测精度</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±0.5℃</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">湿度检测范围</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0-99%RH</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">检测精度</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±3%</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="2" style="word-break: break-all;" align="left">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">噪声检测模块</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">噪声检测范围</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">30-120dB</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">噪声检测精度</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±0.1dB</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="2" style="word-break: break-all;" align="left">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">空气质量检测模块</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">测量范围<br/></span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0-1000ug/m<sup>3</sup></span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">噪声检测精度</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±0.1ug/m<sup>3</sup></span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="3" style="word-break: break-all;" align="left">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">风速仪</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">风速精度</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±（0.2+0.0.3V）m/s</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">测量范围</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">默认0-30m/s</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">分辨率</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0.1m/s</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="2" style="word-break: break-all;" align="left">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">风向仪</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">测量范围</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">8个指示方向/0-360°</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">测量精度</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±1°</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="2" style="word-break: break-all;" align="left">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">充电桩</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">电源</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">AC200V</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">输出功率<br/></span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">24V，≤20A</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '    </tbody>\n' +
          '</table>\n' +
          '<p>\n' +
          '    <br/>\n' +
          '</p>',
        'download':''
      },
        {
          'id': 'a-3',
          'name': '开关室巡检机器人',
          'path': './static/images/l2p/l2p1.jpg',
          'pathS': './static/images/l2p/l2p3.png',
          'model':'YNEN-9X L2p',
          'useFor':'变电站日常运维',
          'imgList':['./static/images/l2p/l2.jpg'],
          'overview': '<p style="line-height: 1.5em;">\n' +
            '<span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(62, 62, 63);">开关室作为电网末端关键节点，其设备运行状况直接影响终端用户的用电可靠性。但由于其数量多、范围广，依赖人工巡 检工作量浩大。特别是随着开关室设备业主越来越关注效率、效益，设备越来越多、运维要求越来越高、运维人员却越来 越少的矛盾将更加突出。因此，通过智能设备来解决运维困境将成为必然。</span>\n' +
            '</p>\n' +
            '<p style="line-height: 1.5em;">\n' +
            '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(62, 62, 63);"><br/></span>\n' +
            '</p>\n' +
            '<p style="line-height: 1.5em;">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(62, 62, 63);">YNEN-9X L2P开关室巡检机器人是一款专为<ins>开关室运维</ins>设计的智能产品。它基于边缘计算框架设计，能根据开关室的运 维要求，实现数据采集、分析的自动化，独立完成开关室的全部运维巡检任务。</span>\n' +
            '</p>\n' +
            '<p style="line-height: 1.5em;">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(62, 62, 63);"><br/></span>\n' +
            '</p>\n' +
            '<p style="line-height: 1.5em;">\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(62, 62, 63);">YNEN-9X L2P开关室巡检机器人功能配置表：</span></strong>\n' +
            '</p>\n' +
            '<p style="line-height: 1.5em;">\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(62, 62, 63);"></span></strong>\n' +
            '</p>\n'+
            '<p>\n' +
            '    <img style="width: 80%" src="./static/images/l2p/l2p-2.png"/>\n' +
            '</p>\n'+
            '<p style="line-height: 1.5em;">\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(62, 62, 63);">产品结构</span></strong>\n' +
            '</p>\n'+
            '<p style="line-height: 1.5em;">\n' +
            '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(62, 62, 63);"><br/></span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <img style="width: 80%" src="./static/images/l2p/l2p-3.png"/>\n' +
            '</p>\n'+
            '<p style="line-height: 1.5em;">\n' +
            '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(62, 62, 63);"><br/></span>\n' +
            '</p>\n' +
            '<p style="line-height: 1.5em;">\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(62, 62, 63);">产品优势</span></strong>\n' +
            '</p>\n'+
            '<p style="line-height: 1.5em;">\n' +
            '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(62, 62, 63);"><br/></span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <img style="width: 80%" src="./static/images/l2p/l2p-4.png"/>\n' +
            '</p>\n'
          ,
          'parameter':'<table data-sort="sortDisabled">\n' +
            '    <tbody>\n' +
            '        <tr class="firstRow">\n' +
            '            <td width="252" valign="middle" style="word-break: break-all;" rowspan="15" colspan="1" align="left">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">开关室巡检机器人</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">导航定位误差</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤100mm</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">最大运动速度</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥1m/s</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">最小制动距离</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤0.5m</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">最小越障高度</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">50mm</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">最小涉水深度</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">100mm</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">爬坡能力</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥20°</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">最小转弯直径</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤本体长度</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">云台性能</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">垂直范围：-15°- 90°</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">水平范围：-180°-180°</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">可见光分辨率</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1080P</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">光学变焦</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">30倍</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">仪表识别准确率</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">98%</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">红外测温准确度</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±2℃或±2%</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">红外测温范围</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">-20℃ ~ 200℃</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">电池续航能力</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥8h</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">电池充满时间</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥5h</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" colspan="1" rowspan="4" style="word-break: break-all;" align="left">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">温湿度监测模块</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">温度检测范围</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">-20℃ - 99℃</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">检测精度</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±0.5℃</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">湿度检测范围</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0 - 99%RH</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">检测精度</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±3%</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" colspan="1" rowspan="2" style="word-break: break-all;" align="left">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">噪声检测模块</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">噪声检测范围</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">30 - 120dB</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">噪声检测精度</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±0.1dB</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" colspan="1" rowspan="2" style="word-break: break-all;" align="left">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">空气质量检测模块</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">检测范围</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0 - 1000ug/m<sup>3</sup></span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">检测精度</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±1ug/m<sup>3</sup></span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" colspan="1" rowspan="4" style="word-break: break-all;" align="left">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">SF<sub>6</sub>气体泄漏监测</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">SF<sub style="white-space: normal;">6</sub>报警阈值</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1000 x 10 - 6</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">准确度</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">＜5%</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">O<sub>2</sub>监测范围</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1.0 - 25%</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">准确度</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">＜5%</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" colspan="1" rowspan="3" style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">局部放电监测</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 12px;">（超声波）</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">中心频率</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">40kHz</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">测量灵敏度</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">-60dB</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">测量范围</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">-60dB - 18dB</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '    </tbody>\n' +
            '</table>\n' +
            '<p>\n' +
            '    <br/>\n' +
            '</p>',
          'download':''
        },
        {
          'id': 'a-4',
          'name': '管廊智能巡检机器人',
          'path': './static/images/g5/tu-6.png',
          'pathS': './static/images/g5/tu-5.png',
          'model':'YNEN-9X G5',
          'useFor':'变电站日常运维',
          'imgList':['./static/images/g5/1-1_01.png','./static/images/g5/1-1_02.gif'],
          'overview':
            '<p style="line-height: 1.5em;">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(63, 63, 63);"></span><span style="font-family: 方正黑体_GBK; font-size: 16px; color: rgb(62, 62, 63);">YNEN-9X G5管廊智能巡检机器人</span>\n' +
            '</p>\n' +
            '<br>\n'+
            '<p style="line-height: 1.5em;">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(63, 63, 63);"></span><span style="font-family: 方正黑体_GBK; font-size: 16px; color: rgb(62, 62, 63);">YNEN-9X G5携带可见光和红外热成像两种图像传感器，可以沿在管廊铺设的轨道巡检，根据预先规划的巡检内容，自动巡检、识别管廊沿线的管线温度，表计，并可以根据要求携带灭火装置，在紧急情况下对失火区域进行灭火。</span>\n' +
            '</p>\n' +
            '<br>\n'+
            '<p>\n' +
            '    <img style="width: 80%" src="./static/images/g5/1-2.png"/>\n' +
            '</p>\n'+
            '<br>\n'+
            '<p>\n' +
            '    <img style="width: 80%" src="./static/images/g5/1-4.png"/>\n' +
            '</p>\n',
          'parameter':'<p>\n' +
            '    <br/>\n' +
            '</p>\n' +
            '<table data-sort="sortDisabled">\n' +
            '    <tbody>\n' +
            '        <tr class="firstRow">\n' +
            '            <td width="231" valign="middle" style="word-break: break-all;" rowspan="44" colspan="1" align="left">\n' +
            '                <p style="margin-top: 25px;">\n' +
            '                    <span style="color: rgb(51, 51, 51); font-family: &#39;Helvetica Neue&#39;, Helvetica, Arial, &#39;Hiragino Sans GB&#39;, &#39;Hiragino Sans GB W3&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, &#39;WenQuanYi Micro Hei&#39;, sans-serif; font-size: 14px; line-height: 21px; background-color: rgb(255, 255, 255);">管廊智能巡检机器人\n</span><br/>\n' +
            '                </p>\n' +
            '                <p style="margin-top: 25px;">\n' +
            '                    <span style="color: rgb(51, 51, 51); font-family: &#39;Helvetica Neue&#39;, Helvetica, Arial, &#39;Hiragino Sans GB&#39;, &#39;Hiragino Sans GB W3&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, &#39;WenQuanYi Micro Hei&#39;, sans-serif; font-size: 14px; line-height: 21px; background-color: rgb(255, 255, 255);">YNEN-9X G5</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" style="word-break: break-all;" rowspan="1" colspan="2" width="21">\n' +
            '                <span style="box-sizing: border-box; font-weight: 700; padding: 0px; margin: 0px; color: rgb(51, 51, 51); font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px; line-height: 21px; background-color: rgb(255, 255, 255);">物理参数</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="231" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">重量<br/></span>\n' +
            '            </td>\n' +
            '            <td width="273" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤30kg</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="231" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">尺寸</span>\n' +
            '            </td>\n' +
            '            <td width="273" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤<span style="font-size: 14px; color: rgb(51, 51, 51); line-height: 21px; background-color: rgb(255, 255, 255);">313mm x 323mm x 400mm</span></span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" rowspan="1" colspan="2" style="word-break: break-all;">\n' +
            '                <span style="box-sizing: border-box; font-weight: 700; padding: 0px; margin: 0px; color: rgb(51, 51, 51); font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px; line-height: 21px; background-color: rgb(255, 255, 255);">电源参数</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="231" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">供电方式</span>\n' +
            '            </td>\n' +
            '            <td width="273" valign="top" style="word-break: break-all;">\n' +
            '                <span style="color: rgb(51, 51, 51); font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px; line-height: 21px; background-color: rgb(255, 255, 255);">锂电池+供电式充电方式</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="231" valign="top" style="word-break: break-all;">\n' +
            '                <span style="color: rgb(51, 51, 51); font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px; line-height: 21px; background-color: rgb(255, 255, 255);">电池容量</span>\n' +
            '            </td>\n' +
            '            <td width="273" valign="top" style="word-break: break-all;">\n' +
            '                <span style="color: rgb(51, 51, 51); font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px; line-height: 21px; background-color: rgb(255, 255, 255);">DC24v@20AH</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="231" valign="top" style="word-break: break-all;">\n' +
            '                <span style="color: rgb(51, 51, 51); font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px; line-height: 21px; background-color: rgb(255, 255, 255);">电池续航</span>\n' +
            '            </td>\n' +
            '            <td width="273" valign="top" style="word-break: break-all;">\n' +
            '                <span style="color: rgb(51, 51, 51); font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px; line-height: 21px; background-color: rgb(255, 255, 255);">巡航时间&gt;5h</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" style="word-break: break-all;" rowspan="1" colspan="2">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;;"><strong><span style="font-family: &#39;Helvetica Neue&#39;, Helvetica, Arial, &#39;Hiragino Sans GB&#39;, &#39;Hiragino Sans GB W3&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, &#39;WenQuanYi Micro Hei&#39;, sans-serif; color: rgb(51, 51, 51); font-size: 14px; line-height: 21px; background-color: rgb(255, 255, 255);">运动参数</span></strong></span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="231" valign="top" style="word-break: break-all;">\n' +
            '                <span style="color: rgb(51, 51, 51); font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px; line-height: 21px; background-color: rgb(255, 255, 255);">行走方式</span>\n' +
            '            </td>\n' +
            '            <td width="273" valign="top" style="word-break: break-all;">\n' +
            '                <span style="color: rgb(51, 51, 51); font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px; line-height: 21px; background-color: rgb(255, 255, 255);">轨道运行</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="color: rgb(51, 51, 51); font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px; line-height: 21px; background-color: rgb(255, 255, 255);">行走速度</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="color: rgb(51, 51, 51); font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px; line-height: 21px; background-color: rgb(255, 255, 255);">0-0.3m/s</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">巡检速度</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0.1m/s</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">定位精度</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±1mm<br/></span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">行走安全</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">双向雷达避障，探测距离0.5m</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">转弯半径</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥500mm</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="2" rowspan="1" style="word-break: break-all;">\n' +
            '                <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">通讯系统参数</span></strong>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">通信系统</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">支持WIFI</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">无线标准</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">IEEE 802.11b/g/n</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">通讯速率</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">不小于20Mbps/台</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">无线安全认证</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">支持RADIUS认证协议</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="2" rowspan="1" style="word-break: break-all;">\n' +
            '                <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">云台参数</span></strong>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">云台类型</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">带可见光相机和热成像仪</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">IP防护</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">不低于IP66</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">转动类型</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">水平方向3600° 连续转动，</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">垂直方向±90°转动</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">转动速度</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">水平0.1~80°/s，垂直0.1~40°/s</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">供电电源</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">DC24V，功率小于50w</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">工作温度</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">-30℃至+60℃（带自动辅热功能）</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="2" rowspan="1" style="word-break: break-all;">\n' +
            '                <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">摄像机参数</span></strong>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">机芯类型</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">一体化防抖机芯，能抑制5~15Hz的振动，光学变焦不低于20倍</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">分辨率</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1080P高清（1920 x 1080）</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">镜头焦距</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">优于5-100mm</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">视场角</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">不低于60度</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">最低照度</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0.1Lux</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">聚焦</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">自动/手动</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">耀斑消除功能</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">支持</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">亮度自适应</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">支持</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="2" rowspan="1" style="word-break: break-all;">\n' +
            '                <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">红外热成像仪参数</span></strong>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">传感器类型</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">焦平面阵列（FPA），非制冷微热量型</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">波长范围</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">8-14μm</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">分辨率</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">不小于640 x 480像素</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">测热范围</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">-20℃to+200℃</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">热温灵敏度</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0.05℃</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">测温精度</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±2℃或读数的±2％</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">测温精度输出</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">不小于9Hz输出</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">视场角</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">大于32°x 24°</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="2" colspan="1" style="word-break: break-all;" align="left">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">氧气监测</span>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;"><span style="font-family: &#39;Helvetica Neue&#39;, Helvetica, Arial, &#39;Hiragino Sans GB&#39;, &#39;Hiragino Sans GB W3&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, &#39;WenQuanYi Micro Hei&#39;, sans-serif; font-size: 14px; color: rgb(51, 51, 51); line-height: 21px; background-color: rgb(255, 255, 255);">O</span><span style="font-family: &#39;Helvetica Neue&#39;, Helvetica, Arial, &#39;Hiragino Sans GB&#39;, &#39;Hiragino Sans GB W3&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, &#39;WenQuanYi Micro Hei&#39;, sans-serif; font-size: 14px; box-sizing: border-box; padding: 0px; margin: 0px; color: rgb(51, 51, 51); line-height: 1.5;">₂监测范围</span></span>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="color: rgb(51, 51, 51); font-family: &#39;Helvetica Neue&#39;, Helvetica, Arial, &#39;Hiragino Sans GB&#39;, &#39;Hiragino Sans GB W3&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, &#39;WenQuanYi Micro Hei&#39;, sans-serif; font-size: 14px; line-height: 21px; background-color: rgb(255, 255, 255);">1.0-25%</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="color: rgb(51, 51, 51); font-family: &#39;Helvetica Neue&#39;, Helvetica, Arial, &#39;Hiragino Sans GB&#39;, &#39;Hiragino Sans GB W3&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, &#39;WenQuanYi Micro Hei&#39;, sans-serif; font-size: 14px; line-height: 21px; background-color: rgb(255, 255, 255);">准确度</span>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="color: rgb(51, 51, 51); font-family: &#39;Helvetica Neue&#39;, Helvetica, Arial, &#39;Hiragino Sans GB&#39;, &#39;Hiragino Sans GB W3&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, &#39;WenQuanYi Micro Hei&#39;, sans-serif; font-size: 14px; line-height: 21px; background-color: rgb(255, 255, 255);">&lt;5%</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="2" colspan="1" style="word-break: break-all;" align="left">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">环境温湿度监测<br/></span>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">温度监测范围</span>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">-20℃-99℃</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">湿度检测范围</span>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0-99％RH</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="2" colspan="1" style="word-break: break-all;" align="left">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">噪声监测</span>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">噪声监测范围</span>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">30-120dB</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">噪声分辨率</span>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0.1dB</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="2" colspan="1" style="word-break: break-all;" align="left">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">有害气体监测</span>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">TVOC测量量程</span>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0-60000ppd</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">TVOC显示分辨率</span>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1ppd</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="2" colspan="1" style="word-break: break-all;" align="left">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">烟雾监测</span>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">报警方式</span>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">声/光</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">报警声压级</span>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥85dB/3m</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="2" colspan="1" style="word-break: break-all;" align="left">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">空气质量监测模块</span>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">测量范围</span>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0-1000ug/m³</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">测量精度</span>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±1ug/m³</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="4" colspan="1" style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">智能监控主机</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">YNEN-9XM</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">显示屏</span>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">10寸LCD液晶显示屏</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">无源节点</span>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">2对，报警、风机</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">通信方式</span>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">RS485</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">外形尺寸</span>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" colspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">360 x 270 x 100mm</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '    </tbody>\n' +
            '</table>',
          'download':''
        },
        {
          'id': 'a-5',
          'name': '防爆机器人',
          'path': './static/images/LB/fb.png',
          'pathS': './static/images/LB/fb.png',
          'model':'YNEN-9X LB',
          'useFor':'石油化工等企业重要设备的巡检',
          'imgList':['./static/images/LB/fb.png'],
          'overview':
            '<p style="line-height: 1.5em;">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(63, 63, 63);"></span><span style="font-family: 方正黑体_GBK; font-size: 16px; color: rgb(62, 62, 63);">随着大型石油化工企业、隧道、地铁等建设的不断扩大，油品、燃气、毒气、化学危险品等引起的泄漏爆炸、火灾等灾害隐患不断增加，为加强高危场所的巡检工作，巡检机器人应运而生。</span>\n' +
            '</p>\n' +
            '<br>\n'+
            '<p style="line-height: 1.5em;">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(63, 63, 63);"></span><span style="font-family: 方正黑体_GBK; font-size: 16px; color: rgb(62, 62, 63);">YNEN-9X LB专为<ins>石油化工等企业重要设备的巡检</ins>设计。</span>\n' +
            '</p>\n' +
            '<br>\n'+
            '<p style="line-height: 1.5em;">\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(63, 63, 63);">安全：</span></strong><span style="font-family: 方正黑体_GBK; font-size: 16px; color: rgb(62, 62, 63);">搭载一系列传感器，可代替巡检人员进入易燃易爆、有毒、缺氧、浓烟等现场进行巡检、探测，有效解决巡检人员在上述场所面临的人身安全。</span>\n' +
            '</p>\n' +
            '<br>\n'+
            '<p style="line-height: 1.5em;">\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(63, 63, 63);">高效：</span></strong><span style="font-family: 方正黑体_GBK; font-size: 16px; color: rgb(62, 62, 63);">数据采集准确，图像清晰，故障报警及时，节省了大量的人力物力，替代了人工巡检工作</span>\n' +
            '</p>\n' +
            '<br>\n'+
            '<p>\n' +
            '    <img style="width: 80%" src="./static/images/LB/jgt.png"/>\n' +
            '</p>\n',
          'parameter':'<p>\n' +
            '    <br/>\n' +
            '</p>\n' +
            '<table data-sort="sortDisabled">\n' +
            '    <tbody>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="2"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">防爆机器人</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">YNEN-9X LB</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="middle" rowspan="1"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">防爆等级</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">Ex db eb IIB T6 Gb</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="1"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">防护等级</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">IP65</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="7"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">运动模块</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="middle" rowspan="1"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">导航定位误差</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤100mm</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="1"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">最大运动速度</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥1m/s</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="1"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">最小制动距离</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤0.5m</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="1"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">最小越障高度</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">50mm</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="1"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">最小涉水深度</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">100mm</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="1"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">爬坡能力</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥20°</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="1"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">最小转弯直径</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤本体长度</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="2"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">云台模块</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="middle" rowspan="1"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">垂直范围</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">-15°~90°/-90°~90°</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="1"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">水平范围</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">-180°~180°</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="3"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">可见光模块</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="middle" rowspan="1"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">可见光分辨率</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1080P</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="1"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">光学变焦</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">30倍</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="1"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">仪表识别准确率</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">99%</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="2"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">红外模块</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="middle" rowspan="1"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">红外测温准确度</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">± 2℃或 ± 2%</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="1"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">红外测温范围</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0℃~350℃</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="2"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">电池模块</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="middle" rowspan="1"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">电池续航能力</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥8h</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" rowspan="1"  style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">电池充满时间</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤5h</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '    </tbody>\n' +
            '</table>'+
            '</br>'+
            '<p>*具体参数以实际订货内容为准</p>',
          'download':''
        },
        {
          'id': 'a-6',
          'name': '电客车智能巡检机器人',
          'path': './static/images/9xt/main.png',
          'pathS': './static/images/9xt/main.png',
          'model':'YNEN-9XT',
          'useFor':'专为地铁、高铁等轨道交通领域设计',
          'imgList':['./static/images/9xt/main.png','./static/images/9xt/dkc02.png','./static/images/9xt/dkc03.png'],
          'overview':'<p style="line-height: 1.5em;">\n' +
            '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">近年来，我国轨道交通事业实现了重大跨越和加快发展，建设规模创下历史新高。伴随着大量轨道交通基础设施相继进入养护期，线路安全和监测面临压力逐渐增大。</span>\n' +
            '</p>\n' +
            '<p style="line-height: 1.5em;">\n' +
            '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">YNEN-9XT专为<ins>地铁、高铁等轨道交通领域</ins>设计。&nbsp;</span>\n' +
            '</p>\n' +
            '<p style="line-height: 1.5em;">\n' +
            '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(62, 62, 63);"><br/></span>\n' +
            '</p>\n' +
            '<p style="line-height: 1.5em;">\n' +
            '   <strong><span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">1.巡检数量多且类型复杂</span></strong>\n' +
            '</p>\n' +
            '<p style="line-height: 1.5em;">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(63, 63, 63);"></span><span style="font-family: 方正黑体_GBK; font-size: 16px; color: rgb(62, 62, 63);">可以单次巡检内容包括五大类12000余个零件检测项目</span>\n' +
            '</p>\n' +
            '<p style="line-height: 1.5em;">\n' +
            '   <strong><span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">2.巡检质量高且准确</span></strong>\n' +
            '</p>\n' +
            '<p style="line-height: 1.5em;">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(63, 63, 63);"></span><span style="font-family: 方正黑体_GBK; font-size: 16px; color: rgb(62, 62, 63);">对数据的研判精度可以达到1毫米，处于国内同类型产品中的领先地位</span>\n' +
            '</p>\n' +
            '<p style="line-height: 1.5em;">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(63, 63, 63);"></span><span style="font-family: 方正黑体_GBK; font-size: 16px; color: rgb(62, 62, 63);">找出细微病害且不受光线等外部环境影响</span>\n' +
            '</p>\n' +
            '<p style="line-height: 1.5em;">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(63, 63, 63);"></span><span style="font-family: 方正黑体_GBK; font-size: 16px; color: rgb(62, 62, 63);">识别准确率≥98%</span>\n' +
            '</p>\n' +
            '<p style="line-height: 1.5em;">\n' +
            '   <strong><span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">3.巡检速度快且持久</span></strong>\n' +
            '</p>\n' +
            '<p style="line-height: 1.5em;">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(63, 63, 63);"></span><span style="font-family: 方正黑体_GBK; font-size: 16px; color: rgb(62, 62, 63);">单次巡检时间≤45min，效率大幅度提升</span>\n' +
            '</p>\n' +
            '<p style="line-height: 1.5em;">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(63, 63, 63);"></span><span style="font-family: 方正黑体_GBK; font-size: 16px; color: rgb(62, 62, 63);">单台机器人可连续工作8小时，每台可完成10列电客车的巡检工作</span>\n' +
            '</p>\n' +
            '<p style="line-height: 1.5em;">\n' +
            '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(62, 62, 63);"><br/></span>\n' +
            '</p>\n' +
            '<p style="line-height: 1.5em;">\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(62, 62, 63);">产品结构</span></strong>\n' +
            '</p>\n'+
            '<p style="line-height: 1.5em;">\n' +
            '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(62, 62, 63);"><br/></span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <img style="width: 80%" src="./static/images/9xt/wgjg.png"/>\n' +
            '</p>\n'+
            '<p style="line-height: 1.5em;">\n' +
            '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(62, 62, 63);"><br/></span>\n' +
            '</p>\n' +
            '<p style="line-height: 1.5em;">\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(62, 62, 63);">系统机构</span></strong>\n' +
            '</p>\n'+
            '<p style="line-height: 1.5em;">\n' +
            '    <span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(62, 62, 63);"><br/></span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <img style="width: 80%" src="./static/images/9xt/xtjg.png"/>\n' +
            '</p>\n'
          ,
          'parameter':'<table data-sort="sortDisabled">\n' +
            '    <tbody>\n' +
            '        <tr class="firstRow">\n' +
            '            <td width="252" valign="middle" style="word-break: break-all;" rowspan="28" colspan="1" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">电客车智能巡检机器人</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">YNEN-9XT</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">名称</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">参数</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">云台摄像机可见光分辨率</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1080P</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">云台摄像机光学变焦</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">30倍</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">图像识别准确率</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥95%</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">缺陷识别漏保率</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">车号识别准确率</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥99.9%</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">单列车辆检测时间</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤45min</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">相邻巡检地沟间转运时间</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤5min</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">机械臂行程</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">100-210cm</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">机械臂自由度</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥6</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">机械臂精度</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤±0.1mm</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">机械臂速度</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥1m/s</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">连续工作时间</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥8hm</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">电池充满时间</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤5h</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">最小制动距离</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤0.5m</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">爬坡能力</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤20°(负重100kg)</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">导航方式</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">视觉导航+激光雷达导航复合方式</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">导航定位精度</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤± 5mm</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">驱动方式</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">四轮独立驱动</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">行走方向</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">前进、后退全向</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">最大行走速度</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≥1m/s</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">最小转弯半径</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤750mm</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">驱动能力</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">负重≤100kg</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">障碍物探测方式</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">光电式</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">供电方式</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">电池供电</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">电池容量</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">DC48V，60Ah</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">电池电量显示</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">支持</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '    </tbody>\n' +
            '</table>\n' +
            '<p>\n' +
            '    <br/>\n' +
            '</p>'+
            '<p>说明：以上模块功能，可自由选择搭配</p>',
          'download':''
        },
      ]
    },
    {
      'id': 'b',
      'kind': '电气监测',
      'child': [{
        'id': 'b-1',
        'name': '居配电站智能监控系统',
        'path': './static/images/jp-1.png',
        'useFor':'智能电网\n',
        'model':'ES-9000X',
        'imgList':['./static/images/jp-1.png'],
        'overview':'<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">居配电站作为电网末端的关键节点，是智能电网建设的重要组成部分。近年来，随着水涝、盗窃等情况的不断出现，&nbsp;严重影响了电网运行安全，降低了供电可靠性。因此，加强居配电站监控、管理，确保其正常运行，有着重要意义。</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">&nbsp;</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">ES-9000X居配电站智能监控系统，就是针对上述监管要求，融入智能电网智能化监测需要，促进居配电站标准化建设。</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">&nbsp;</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">ES-9000X居配电站智能监控系统主要对如下13种对象进行监测：&nbsp;</span></strong>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">1、溢水报警<br/></span></strong>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">2、智能门禁</span></strong>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">3、视频监测</span></strong>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">4、防盗</span></strong>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">5、消防</span></strong>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">6、电能质量</span></strong>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">7、SF6泄漏</span></strong>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">8、环境温湿度</span></strong>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">9、变压器超温</span></strong>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <strong><span style="color: rgb(38, 38, 38); font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8;">10、开关柜温湿度（排水法除湿）</span></strong>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">11、开关柜触头测温</span></strong>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">12、开关柜局部放电</span></strong>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">13、断路器分合状态</span></strong>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">&nbsp;</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">ES-9000X为居配电站提供了通信平台，可以实现信息的遥测、遥信、遥控。运行人员也可以用手机等移动终端、计算&nbsp;机连接到互联网，查看信息，也可以直接通过手机、计算机，远程开门、控制风机。</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <br/>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">&nbsp;<strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(38, 38, 38);">系统组成&nbsp;</span></strong><br/></span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <br/>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">&nbsp;</span><img style="width: 80%;" src="./static/images/jp-2.png"/>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <br/>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <br/>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <br/>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">&nbsp;<strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(38, 38, 38);">主要功能</span></strong></span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">&nbsp;</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;;font-weight: bold; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">1、溢水报警&nbsp;</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">溢水时报警，支持排水接点输出功能。&nbsp;</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;;font-weight: bold; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">2、智能门禁</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">停电时也可开门，远程计算机、移动终端可遥控开门。</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;;font-weight: bold; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">3、集成5种环境监测&nbsp;</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">同时支持图像、防盗、消防、SF6泄漏、环境温湿度五种环境参数监测，并可根据环境温湿度或远程开启风机。&nbsp;</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;;font-weight: bold; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">4、变压器超温监测</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">直接采集变压器温度，超限即报警。</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;;font-weight: bold; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">5、开关柜温湿度监测&nbsp;</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">对开关柜内温湿度进行监测，同时通过排水法直接将柜内湿气冷凝成水排出柜外，确保柜内干燥。&nbsp;</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;;font-weight: bold; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">6、开关柜触头测温</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">无源无线触头温度监测技术，无需电池，也可实现高达20年的连续监测。</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <br/>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">&nbsp;</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="color: rgb(38, 38, 38);"><strong><span style="color: rgb(38, 38, 38); font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px;">产品优势</span></strong></span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">&nbsp;</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;;font-weight: bold; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">1、最全面的监测，覆盖居配电站全部监测要素&nbsp;</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">满足居配电站数量多、无人值守情况下全面监测要求&nbsp;</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">集成高达13种对象的监测，并按需扩展&nbsp;</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">发现异常及时将数据告知运行人员，消除安全隐患</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;;font-weight: bold; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">2、先进的传感和控制技术</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">4G通讯，支持路径传输，在办公室也能看到现场情况</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">电柜湿度自动监测和排水法除湿，直接将湿气冷凝成水&nbsp;</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">先进的无源触头测温技术，无需电池，还可实现高达20年的连续监测</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;;font-weight: bold; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">3、智能化的网络平台&nbsp;</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">多种网络接入方式：以太网，高速移动网络&nbsp;</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">计算机、移动终端自适应，B/S架构，无须安装即可使用&nbsp;</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(38, 38, 38);">远程查看数据、实时图像，并可操作相关设备，如风机等</span>\n' +
          '</p>\n' +
          '<p>\n' +
          '    <br/>\n' +
          '</p>',
        'parameter':'<table data-sort="sortDisabled">\n' +
          '    <tbody>\n' +
          '        <tr class="firstRow">\n' +
          '            <td width="252" valign="middle" style="word-break: break-all;" rowspan="4" colspan="1" align="left">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">居配电站只能监控主机</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">ES-9000X</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">集成居配电站13中对象监测</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">可遥控风机、开门、布防、解锁；可以查看高清晰图像支持光纤、RJ、移动以太网接入</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">通信方式</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">RS485</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">无源接点</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">2对，报警、风机</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">外形尺寸</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">360 x 270 x 100mm<sup>3</sup>(长 x 宽 x 高)</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="middle" style="word-break: break-all;" rowspan="2" colspan="1" align="left">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">居配电站智能监控服务器</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">ES-9000XS</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">通信方式</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">RS485:3对</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">光纤、以太网</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">工作电源</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">AC220V(DC220、DC110可选）<br/></span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="middle" style="word-break: break-all;" rowspan="4" colspan="1" align="left">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">智能门禁</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">YNEN-IM</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">系统包括</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">门禁读卡器、门禁控制器、电控锁、远程授权数据下载</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">配备备用电源</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">停电仍可继续保证开门</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">支持卡片类型</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">IC卡</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">通信方式</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">RS485</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="3" style="word-break: break-all;" align="left">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">溢水报警传感器</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">YNEN-SW-1</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">监测电缆沟内水位</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">发现溢水，即可自动报警，溢水时可自动启动排水泵排水</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">水位监测准确度</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0.5cm</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">通信方式<br/></span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">RS485</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="3" style="word-break: break-all;" align="left">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">防盗监测</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">YNEN-FD-02</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">技术特性<br/></span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">刷卡进入时自动解警，无授权进入视为非法入侵，并报警</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">红外、微波组合监测，防止误报</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">探测距离</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">5m</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">通信方式</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">RS485</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="2" style="word-break: break-all;" align="left">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">数字延误变送器</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">YNEN-YW-03</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">技术特性</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">监测烟雾后自动报警</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">通信方式</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">RS485（1对，上传）</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="4" style="word-break: break-all;" align="left">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">视频监测</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">YNEN-SP1</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">摄像头</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">500万像素</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">传感器类型</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">CMOS</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">对焦方式</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">自动对焦</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">通信方式&nbsp;</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">以太网</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="6" style="word-break: break-all;" align="left">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">排水型电柜除湿器</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">YNEN-CS3</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">技术特性</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">直接将湿气冷凝成睡排出柜外，带温湿度监测功能</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">温度测量准确度</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±1℃</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">湿度测量准确度</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±5%RH</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">湿度启动阀值</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">65%RH</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">除湿量</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">350ml/24h（35℃，85%RH环境下）</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">通信方式</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">RS485</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="6" style="word-break: break-all;" align="left">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">SF<sub>6</sub>和O<sub>2</sub>气体监测变送器</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">SJ-3</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">技术特性</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">SF<sub style="white-space: normal;">6</sub>气体和O<sub style="white-space: normal;">2</sub>气体综合监测</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">SF<sub style="white-space: normal;">6</sub>测量报警值</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1000 x 10<sup>-6</sup></span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">O<sub>2</sub>测量报警值</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">18%</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">SF<sub style="white-space: normal;">6</sub>测量准确度</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±10%（全量程）</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">O<sub style="white-space: normal;">2</sub>测量准确度</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±0.5%</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">通信方式</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">RS485</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="4" style="word-break: break-all;" align="left">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">温湿度监测变送器</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">WSJ-2</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">技术特性</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">温度和湿度综合监测</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">温度测量准确度</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±1℃</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">湿度测量准确度</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±5%RH</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">通信方式</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">RS485</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="3" style="word-break: break-all;" align="left">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">无源无线高压设备温度监测装置</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">ES-9000T</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">技术特性<br/></span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">无需电池即可工作，直接通过电压感应取电不受电流影响，不会因为过流孙华等电位设计，不受电压影响出乎想象的抄底功耗设计先进的声表面通信技术</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">测量准确度</span>\n' +
          '            </td>\n' +
          '            <td width="252" valign="top" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±1℃</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">通信方式</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">RS485：1对，上传</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">无源接点：1对，报警</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="4" style="word-break: break-all;" align="left">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">局部放电变送器</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">ES-9000G</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">工作电压</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">AC220V±20%</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">功率</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">≤35W</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">输出电源</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">DC12V</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">尺寸</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">465 x 170 x 100mm<sup style="white-space: normal;">3</sup>(长 x 宽 x 高)</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="2" style="word-break: break-all;" align="left">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">报警灯</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">BJD-G</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">技术特性</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">安装在监测区域入口处</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">光指示型</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">外形尺寸</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">φ100mm x 70mm</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="2" style="word-break: break-all;" align="left">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">智能不习惯防盗防火大门</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">YNEN-XFM2</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">智能防盗系统</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">AB式防盗锁，专备施工钥匙；外来破坏、侵入实时监测</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">支持数据上传，现场报警、短信报警 智能门禁控制</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">外形尺寸</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">定制</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="2" style="word-break: break-all;" align="left">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">安全工具柜</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">YNEN-ANZ-1</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">技术特性</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">居配电站专用安全工具柜</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">标准尺寸</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">850 x 550 x 2000mm<sup style="white-space: normal;">3</sup>(长 x 宽 x 高)</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="1" style="word-break: break-all;" align="left">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">不修改低噪音风机</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-4F/ZS</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">技术特性</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">一体化设计，外形美观</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">不锈钢壳体，铝合金电机叶片，防止锈蚀</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">大风量、低噪音，最低40dB，转为居配电站设计，防止扰民</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">外置自动百叶，内置防虫网</span>\n' +
          '                </p>\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">可伸缩支架，在一定范围可适合不同墙厚</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="5" style="word-break: break-all;" align="left">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">节点控制器</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">电源输入</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">DC12V-DC24V</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">支持路数</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">双路</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">触点容量</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">AC250V@3A</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">通信方式</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">RS485</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">地址设定范围</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <p>\n' +
          '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1-32</span>\n' +
          '                </p>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="middle" colspan="1" rowspan="8" style="word-break: break-all;" align="left">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">电能质量</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">电源</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">AC/DC85~265V,≤10VA</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">电能脉冲</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">光耦集电机输出（内部无源）</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">显示方式</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">LCD液晶显示</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">复费率</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">可设8-12时段</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">通信方式</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">RS485</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">工作环境</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">-10~55℃，相对湿度＜95%</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">储存环境</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">-20~75℃，相对湿度＜95%</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '        <tr>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">外形尺寸</span>\n' +
          '            </td>\n' +
          '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
          '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">120 x 120x 86mm<sup style="white-space: normal;">3</sup>(长 x 宽 x 高)</span>\n' +
          '            </td>\n' +
          '        </tr>\n' +
          '    </tbody>\n' +
          '</table>\n' +
          '<p>\n' +
          '    <br/>\n' +
          '</p>'
        ,
        'download':''
      },
        {
          'id': 'd-1',
          'name': 'SF6气体泄漏监控报警系统',
          'path': './static/images/sf6.png',
          'useFor':'SF6开关室',
          'imgList':['./static/images/sf6.png'],
          'overview':'<p>\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">ES-9000B系列SF6气体泄漏监控报警系统，是一种为进入SF6开关室（包括GIS等SF6配电装置室）的工作人员提供人身安全防护的环境空气监测装置。它能实时、在线监测环境空气中SF6气体和氧气体含量，独具的微量SF6气体监测术，能最低监测到50ppm（50×10-6v/v）SF6含量。</span></strong>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">当环境空气中SF6气体含量超标（SF6气体浓度&gt;1000ppm）、或缺氧（氧浓度&lt;18%），ES-9000B监控报警系统都&nbsp;能立即进行声光报警，提醒现场工作人员迅速撤离；同时，系统自动启动风机来降低环境空气中SF6气体含量；在预&nbsp;设数据上传接口后，系统也能将实时监测数据和报警信号传送至控制室或远控，为在SF6开关室的工作人员提供一道&nbsp;完整、可靠的人身安全保障。</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">由于ES-9000B系列SF6气体泄漏监控报警系统能监测到微量SF6气体泄漏，对SF6开关安全也能起到一定的预警作用。 本系统可广泛应用于各种电压等级的SF6开关室、GIS、SF6变压器室等。&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">本产品符合《GB12358作业环境气体检测报警仪通用技术要求》标准要求。</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="color: rgb(63, 63, 63); font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px;">主要功能</span></strong>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">1.&nbsp;齐全的检测功能&nbsp;</span></strong>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">SF6气体检测&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">氧气体检测&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">温湿度检测</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">2.&nbsp;完善的报警和应急处理能力</span></strong>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">SF6气体泄漏超标报警&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">缺氧报警</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">温湿度超限报警&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">报警时自动启动风机</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">3.&nbsp;按需设置和应用&nbsp;</span></strong>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">多区域同时监测&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">各区域可单独启动风机&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">定时排风</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">强制排风</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">4.&nbsp;人性化便利</span></strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">监测和报警数据远传&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">触摸屏设计</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">人体感应自动语音提示并打开液晶屏&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">液晶屏背光自动关闭</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <br/> \n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="color: rgb(63, 63, 63);font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;;"><strong>SF6气体泄漏监测 |&nbsp;定性</strong></span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">其他产品部件与各型号主机接口统一，可以任意选配，包括各种气体监测变送器、温湿度监测变送器、风机控制器、 电源与信号中继器、SF6气体监测报警灯。</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <img style="width: 80%" src="./static/images/sf6-01.png"/>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;"><strong><span style="color: rgb(63, 63, 63); font-family: 微软雅黑, &#39;Microsoft YaHei&#39;;">SF6气体泄漏监测 |&nbsp;定量</span></strong></span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <img style="width: 80%" src="./static/images/sf6-02.png"/>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <br/>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <br/>\n' +
            '</p>\n'+
            '<table>\n' +
            '    <tbody>\n' +
            '        <tr class="firstRow">\n' +
            '            <td width="147" valign="top" style="word-break: break-all; background-color: rgb(187, 187, 187);">\n' +
            '                <p>\n' +
            '                    电缆起点位置\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all; background-color: rgb(187, 187, 187);">\n' +
            '                <p>\n' +
            '                    电缆终点位置\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all; background-color: rgb(187, 187, 187);">\n' +
            '                <p>\n' +
            '                    线路名称\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all; background-color: rgb(187, 187, 187);">\n' +
            '                <p>\n' +
            '                    型号规格\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all; background-color: rgb(187, 187, 187);">\n' +
            '                <p>\n' +
            '                    电缆数量\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                主机\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    电源屏（箱）\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    主机电源线\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    RVV2×1\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    1根\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    主机\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    变送器\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    变送器电源线/&nbsp;通信线\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    RVV2×1/&nbsp;RVV5×0.5\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    1根\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    主机\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    风机控制器\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    风机控制信号\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    RVV2×1\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    1根\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    主机\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    报警灯\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    报警灯电源控制线\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    RVV2×1\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    1根\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    主机\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    报警显示屏\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    报警显示屏电源线\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                RVV2×1\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    1根\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    主机\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    报警显示屏\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    报警显示屏电源线\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    RVVP3×0.5\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="147" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    1根\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '    </tbody>\n' +
            '</table>\n' +
            '<p>\n' +
            '    <br/>\n' +
            '</p>'
          ,
          'parameter':'<table data-sort="sortDisabled">\n' +
            '    <tbody>\n' +
            '        <tr class="firstRow">\n' +
            '            <td width="252" valign="middle" style="word-break: break-all;" rowspan="12" colspan="1" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">SF<sub>6</sub>气体泄漏监控报警系统</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">ES-9000B</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">电源规格类型</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">AC/DC 185~265V&nbsp;</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">SF<sub style="white-space: normal;">6</sub>报警阀值</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1000 x 10 - 6，误差＜5%</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">O<sub>2</sub>检测范围</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1.0~25%，误差＜5%</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">缺氧报警阈值</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">18%</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">温度检测范围</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">-20~99℃</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">湿度检测范围</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0~99%RH<br/></span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">报警输出功率</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">无源，（常开）220V，5A</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">风机输出功率</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">无源，（常开）220V，5A</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">风机控制器功率</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">220V，25A（默认）</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">主机安装方式</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">壁挂式</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" width="252">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">SF<sub style="white-space: normal;">6</sub>气体泄漏报警点用户设置</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;"></td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">缺氧报警点用户设置</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1"></td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" colspan="1" rowspan="2" style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">SF<sub>2</sub>和O<sub>2</sub>气体监测变送器</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">SJ-3</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <br/>\n' +
            '                </p>\n' +
            '                <p style="margin-top: 0px; margin-bottom: 0px; padding: 0px; white-space: normal;">\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">SF<sub>2</sub>和O<sub>2</sub>气体激光监测变送器</span>\n' +
            '                </p>\n' +
            '                <p style="margin-top: 0px; margin-bottom: 0px; padding: 0px; white-space: normal;">\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">SJ-3G</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">技术特性</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">监测SF<sub>6</sub>、DC18V供电、RS485通讯</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">规格</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">180 x 110 x 50mm<sup>3</sup>（长 x 宽 x 高）</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" colspan="1" rowspan="5" style="word-break: break-all;" align="left">\n' +
            '                <p style="margin-top: 0px; margin-bottom: 0px; padding: 0px; white-space: normal;">\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">SF<sub>2</sub>和O<sub>2</sub>气体分析装置</span>\n' +
            '                </p>\n' +
            '                <p style="margin-top: 0px; margin-bottom: 0px; padding: 0px; white-space: normal;">\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">SOJ-8</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">电压</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">DC18V</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">测试精度</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±2%FS</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">量程</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0 - 1000ppm</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">通讯方式</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">RS485</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">规格</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">250 x 150 x 56mm<sup style="white-space: normal;">3</sup>（长 x 宽 x 厚）</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" colspan="1" rowspan="2" style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">温湿度监测变送器</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">WSJ-2</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">技术特性</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">DC18V供电、RS485通讯</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">规格</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">180 x 110 x 50mm<sup style="white-space: normal;">3</sup>（长 x 宽 x 厚）</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" colspan="1" rowspan="2" style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">声光指示型报警灯</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">BJD-G</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">技术特性</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">一般安装在各监测区域入口处</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">规格</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">125 x 75 x 75mm<sup style="white-space: normal;">3</sup>（长 x 宽 x 高）</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" colspan="1" rowspan="2" style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">报警显示屏</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">BXP-4</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">技术特性</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">一般安装在各监测区域入口处。根据主机信号，LED显示现场监测情况，并与人体感应结合自动进行语音提示</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">规格</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">425 x 105 x 25mm<sup style="white-space: normal;">3</sup>（长 x 宽 x&nbsp;厚）</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" colspan="1" rowspan="2" style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">电源与信号中继器</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">ZJQ-4</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">技术特性</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">一般固定在电缆沟内。电源与信号线中继，可分为三路电源与信号输出</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">规格</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">120 x 60 x 36mm<sup style="white-space: normal;">3</sup>（长 x 宽 x&nbsp;厚）</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" colspan="1" rowspan="2" style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">风机控制器</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">FKQ-3</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">技术特性</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">一般安装在风机控制开关所在的PZ-30电气控制盒内，根据主机控制信号，控制单相、三相风机启动和停止</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">规格<br/></span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">45 x 60 x 75mm<sup style="white-space: normal;">3</sup>（长 x 宽 x&nbsp;厚）</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '    </tbody>\n' +
            '</table>\n' +
            '<p>\n' +
            '    <br/>\n' +
            '</p>',
          'download':''
        },
        {
          'id': 'c-1',
          'name': '排水型电柜除湿器',
          'path': './static/images/csq/除湿器.png',
          'model':'YNEN-CS3',
          'useFor':'开关柜、汇控柜、智能组件柜 \n' +
            '（包含屏柜）、箱变等空间较大 的电柜\n',
          'imgList':['./static/images/csq/除湿器.png','./static/images/csq/除湿器-03.png'],
          'overview':'<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: 700;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(63, 63, 63);">概述</span></span>\n' +
            '</p>\n' +
            '<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <br/>\n' +
            '</p>\n' +
            '<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: 700;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">将电柜内的湿气冷凝成水排出柜外，电柜内没有湿气&nbsp;和水分，才能给设备真正干燥的运行环境。</span></span>\n' +
            '</p>\n' +
            '<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">YNEN-CS3排水型电柜除湿器利用湿热空气遇冷会凝&nbsp;露的工作原理，通过电子致冷方法，在产品内部创造最&nbsp;多可低于环境温度30℃的冷端，并通过风扇迫使柜内相&nbsp;对湿热空气经过冷端，从而在冷端不断产生凝露，持续&nbsp;的凝露最终导致凝水，收集凝水并排出电柜外，从而大&nbsp;大降低了电柜内湿气和水分含量，即使外部环境大幅降&nbsp;温时，由于电柜内水分非常少，也不会再产生凝露，真&nbsp;正保持电柜内部干燥。</span>\n' +
            '</p>\n' +
            '<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">传统加热型除湿器除湿主要是通过加热提高电柜内的温 度，促使凝露蒸发成湿气，来防止凝露对设备产生危害。&nbsp;但由于湿气还保留在柜内，当外部环境大幅降温，抵消 加热器加热作用后，湿气仍然将转化为凝露，凝结在电 气设备表面，降低设备绝缘能力，达不到除湿的目的和 效果，从而危害设备安全运行。</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);"><br/></span>\n' +
            '</p>\n' +
            '<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <span style="box-sizing: border-box; margin: 0px; padding: 0px; color: rgb(63, 63, 63);"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-weight: 700;"><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px;">特点</span></span></span>\n' +
            '</p>\n' +
            '<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <br/>\n' +
            '</p>\n' +
            '<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63); font-weight: bold;">超强除湿能力</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">集合空气动力、智能电子调节先进技术，具有高达 400ml/24h强劲除湿能力*1，即使电柜存在缝隙等密封 不良状况*2，也能从容应对，将湿气驱离电柜。</span>\n' +
            '</p>\n' +
            '<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);"><br/></span>\n' +
            '</p>\n' +
            '<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63); font-weight: bold;">超长使用寿命&nbsp;</span>\n' +
            '</p>\n' +
            '<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">排水型电柜除湿器内部存在多个精密器件，均对设计、 制造有严格要求，稍有不慎就会导致产品报废。</span>\n' +
            '</p>\n' +
            '<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">YNEN-CS3经过上百次试验，将YNEN-CS3设计使用&nbsp;寿命提高到10年。第一批产品连续无故障实际运行时间&nbsp;已经超过45000小时。</span>\n' +
            '</p>\n' +
            '<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);"><br/></span>\n' +
            '</p>\n' +
            '<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63); font-weight: bold;">全面的电柜环境解决方案</span><span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">电柜太小无法安装？电柜没有低压电源无法取电？电柜 还怕夏天温度过高？希望全站监控？</span>\n' +
            '</p>\n' +
            '<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">YNEN-CS3均有应对方案，适应各种电柜，满足多种&nbsp;监控需求，让电柜环境控制从此无后顾之忧。</span>\n' +
            '</p>\n' +
            '<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">说明：</span>\n' +
            '</p>\n' +
            '<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">1、400ml/24h为YNEN-CS3-60在35℃、85%RH下除湿量，其&nbsp;他规格型号除湿量参见其参数表。&nbsp;</span>\n' +
            '</p>\n' +
            '<p style="box-sizing: border-box; margin-top: 0px; padding: 0px; font-family: &#39;Microsoft YaHei&#39;; color: rgb(51, 51, 51); style="font-size: 16px;line-height:1.8; line-height: 20px; white-space: normal; margin-bottom: 0px !important; background-color: rgb(255, 255, 255);">\n' +
            '    <span style="box-sizing: border-box; margin: 0px; padding: 0px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">2、电柜缝隙不存在强空气对流。</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <br/>\n' +
            '</p>\n' +
            '<p>\n' +
            '                <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(63, 63, 63);">开关柜除湿\t| 高压室</span></strong>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <br/>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <img src="./static/images/csq/除湿器-01.png"/>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <br/>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <br/>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px;"><br/></span></strong>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px;">YNEN-CS3排水型电柜除湿器 / 传统加热型除湿器 对比表</span></strong>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px;"><br/></span></strong>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px;"></span></strong>\n' +
            '</p>\n' +
            '<table>\n' +
            '    <tbody>\n' +
            '        <tr class="firstRow">\n' +
            '            <td width="260" valign="top" style="word-break: break-all;">\n' +
            '                <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">项目</span></strong>\n' +
            '            </td>\n' +
            '            <td width="260" valign="top" style="word-break: break-all;">\n' +
            '                <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">YNEN-CS3排水型电柜除湿器</span></strong>\n' +
            '            </td>\n' +
            '            <td width="260" valign="top" style="word-break: break-all;">\n' +
            '                <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">传统加热型除湿器</span></strong>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="260" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">原理</span>\n' +
            '            </td>\n' +
            '            <td width="260" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">湿热空气遇冷会凝露，因此通过风扇让湿热空气经过产品内置的冷端，使湿气在冷端上凝露并形成凝水，收集凝水排出电柜外，从而降低电柜内湿气含量，降低电柜内湿度</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">优点：直接将电柜内部湿气冷凝成水排出，由于电柜内部大量减少了湿气，即使外部环境大幅降温，也没有足够的湿气可以形成凝露</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="260" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">温度较高的空气中能容纳更多的水分，加热空气就能使可能凝成露珠的水分保留在空气中，防止凝结在设备表面。</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">缺点：湿气还在电柜内部，如果外部环境环境大幅降温，湿气还是会析出形成凝露，危害设备运行安全</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="260" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">安全</span>\n' +
            '            </td>\n' +
            '            <td width="260" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">产品外壳不发热不会对周围线缆产生影响</span>\n' +
            '            </td>\n' +
            '            <td width="260" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">产品工作时本体很热，会加速周围线缆老化，如与周围线缆直接接触，甚至会破坏线缆绝缘，影响安全</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="260" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">能效</span>\n' +
            '            </td>\n' +
            '            <td width="260" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">电柜内湿度达到阀值自动启动，除湿结束后自动停止工作，较短时间即可完成除湿。以60瓦为例，每天工作2小时，其他时间待机(10瓦)，每年耗电124度</span>\n' +
            '            </td>\n' +
            '            <td width="260" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">需较高功率才能保持电柜内部一定温度，并且需要长时间，以保持电柜内部温度。以 100 瓦为例，每年耗电 876 度</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="260" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">结构</span>\n' +
            '            </td>\n' +
            '            <td width="260" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">湿气监测、除湿一体化结构设计，无需连线</span>\n' +
            '            </td>\n' +
            '            <td width="260" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8; color: rgb(63, 63, 63);">湿气监测、除湿分体设计，两者之间需要接线</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '    </tbody>\n' +
            '</table>\n' +
            '<p>\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px;"></span></strong><br/>\n' +
            '</p>',
          'parameter':'<table data-sort="sortDisabled">\n' +
            '    <tbody>\n' +
            '        <tr class="firstRow">\n' +
            '            <td width="252" valign="middle" style="word-break: break-all;" rowspan="9" colspan="1" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">排水型电柜除湿器</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">YNEN-CS3-60</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">工作电源</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">AC220V</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">额定功率</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">60W</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">显示方式</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">LCD液晶屏显示</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">湿度阀值</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">65%（默认，可调）</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">排水方式</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">软管排水</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">除湿量</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">300ml/24h</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">（温度35℃，湿度85%RH）</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">推荐除湿空间</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1~1.5m<sup>3</sup></span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">通信方式</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">RS485（可选）</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">外形尺寸</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">135 x 130 x 68mm<sup>3</sup></span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" colspan="1" rowspan="8" style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">初始数据终端</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">ES-9000H</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">工作电源</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">AC220V</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">额定功率</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">20W</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">显示器</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">10.1寸TFT，带触摸</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">通信方式</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">RS485</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">报警输出</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">支持，无源</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">故障输出</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">支持，无源</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">安装方式</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">壁挂式</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">外形尺寸</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">360 x 276 x 110mm<sup style="white-space: normal;">3</sup></span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '    </tbody>\n' +
            '</table>\n' +
            '<p>\n' +
            '    <br/>\n' +
            '</p>',
          'download':''

        },
        {
          'id': 'f-1',
          'name': '变压器降噪装置',
          'path': './static/images/byjz/变压器降噪.png',
          'model':'YNEN-CS3',
          'useFor':'配电变压器\n' +
            '居配电站',
          'imgList':['./static/images/byjz/变压器降噪.png','./static/images/byjz/变压器降噪1.png'],
          'overview':
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">作为居配工程重要设备的配电变压器，由于制造和安装等方面的原因，会产生一定噪声，随着使用年限增长，其噪声 也会逞升高趋势。目前因城市建设需要，建筑密度非常大，居配电站一般都离居民区非常近，甚至直接就位于居民楼 或其他建筑物内，这样，变压器噪声就有可能影响到建筑物内人员的工作、生活。在当前人们对环保要求越来越高的 大环境下，只要有人能感受得到的噪声，就会引起居民接连不断的投诉，给电力公司配电运行部门造成很大压力。因 此，采用一款性能可靠、设计简单、安装快捷的变压器降噪设备，是解决由于配电变压器噪声引起诸多矛盾的关键。</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">SK-12变压器降噪装置，是终结变压器噪声的强力武器。</span></strong>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">2014年3月，常州市盈能电气有限公司推出第八代SK-12变压器降噪装置。该产品采用德国技术，在原采用多层复合&nbsp;降噪措施的基础上，进一步优化参数，使噪声抑制率从75%提高到99%。无可匹敌的设计水平，使SK-12变压器降&nbsp;噪装置在行业内赢得声誉，受到客户广泛欢迎。</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">SK-12不仅降噪性能出色，而且使用非常简单，一体化的板状结构，在无需对变压器进行本体进行改动的情况下， 就可以解决噪声干扰。</span></strong>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">SK-12已经通过国家型式试验报告。</span></strong>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="color: rgb(63, 63, 63); font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; style="font-size: 16px;line-height:1.8;"><br/></span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;"><strong><span style="color: rgb(63, 63, 63); font-family: 微软雅黑, &#39;Microsoft YaHei&#39;;">变压器噪声来源分析与对策</span></strong></span><br/>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">一、变压器噪声来源&nbsp;</span></strong>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">变压器噪声是由本体结构设计、选型布局、安装、使用过程中，变压器本体及冷却系统产生的不规则、间歇、连续或随机&nbsp;引起的机械噪声及空气噪声总和。具体来说，变压器噪声共有三个声源，一是铁心，二是绕组，即空载、负载引起噪声之&nbsp;和。铁心产生噪声原因是构成铁心硅钢片交变磁场作用下，会发生微小变化即磁致伸缩，磁致伸缩使铁心随励磁频率变化&nbsp;做周期性振动，铁心磁致伸缩变形和绕组及磁屏蔽内电磁力所引起。绕组产生振动原因是电流绕组中产生电磁力，漏磁场&nbsp;也能使结构件产生振动。电磁噪声产生原因是磁场诱发铁心叠片沿纵向振动产生噪声，该振动幅值与铁心叠片中磁通密度&nbsp;及铁心材质磁性能有关，而与负载电流关系不大。 电磁力(和振动幅值)与电流平方成正比，而发射声功率与振动幅值平方&nbsp;成正比。</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">二、变压器噪声传播途径和对策&nbsp;</span></strong>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">变压器噪声传播主要通过两种途径：&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">(一)、空气传播</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">1、传播：变压器噪声通过空气传播，就象人们说话，马路上汽车喇叭噪声一样，能够为人耳所能听到。</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">2、对策：封闭噪声源环境，例如增加房间的密封程度，包括门、窗的密封。为了防止噪声引起共振(会使噪声扩大)，可以&nbsp;在墙上安装吸音材料。</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">(二)、结构传播&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">1、传播：变压器噪声通过建筑物、构架传播，就象当人贴在钢轨上，就能很远就感觉到列车马上就要过来。这种噪声是一&nbsp;种振动，耳朵一般听不见，但如果伏在与变压器相连的地板上(高度不限)，就可以感受到。当人晚上睡觉时，尤其清晰。通&nbsp;过结构传播的噪声距离非常远，这也是为什么即使20层以上的住户，也能感知到地下配电变压器的振动。&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">2、对策：将变压器与基础隔离，使变压器的噪声无法通过基础传递至整幢大楼。SK-12变压器降噪装置就是针对这种噪声&nbsp;问题的解决方案。</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;"><strong><span style="color: rgb(63, 63, 63); font-family: 微软雅黑, &#39;Microsoft YaHei&#39;;">产品结构</span></strong></span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">SK-12采用五层复合缓冲结构：</span></strong>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">2组压缩式橡胶弹簧；</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">2组螺旋压缩弹簧（1硬性、1柔性）；</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">1组衬套弹簧。&nbsp;这五层复合缓冲结构，具有不同的缓冲系数，在保证变压器承重的前提下，实现了宽频率的噪声抑制。由于这些缓冲结构&nbsp;均没有消耗件，没有维护、保养的工作量，设计寿命超过20年。</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p style="margin-right: 17px">\n' +
            '    <strong><span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">产品特点</span></strong><span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);"> </span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">1、卓越的低自然频率值抑制</span></strong><span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">变压器运行中主要产生的是低频噪声，降噪装置的抑制频率必须与变压器的噪声频率相匹配，才能达到最佳的降噪效果。&nbsp;SK-12采用最新的德国SINKENG低频抑制振动技术，对低自然频率噪声高隔绝，出色降噪性能，抑制率超过99%。从而&nbsp;在降噪技术上，SK-12建立了行业新标杆。</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">2、高荷重可靠性</span></strong>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">变压器自身重量都比较大，常规降噪装置的荷重能力不够，或制造工艺质量不过关，容易造成降噪装置故障，导致变压&nbsp;器倾斜。而过高的荷重能力，又会降低变压器的降噪效果。SK-12变压器降噪装置设计荷重最大可达到10吨。不同规格&nbsp;变压器均能轻松适应。</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">3、模块设计</span></strong>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">SK-12将所有降噪装置全部预装于安装预制盒内，并进行充分调试和测试，无须现场调试，送达安装现场固定即可，不&nbsp;仅安装方便，而且保证安装质量。</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <br/>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">安装方法</span></strong>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <br/>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">1、先将配电变压器按原来设计就位；</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">2、将配电变压器抬起约20cm，将SK-12变压器降噪装置放入变压器下面，并与配电变压器基础槽钢成“井”交叉布置。</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">3、将配电变压器基础槽钢与SK-12变压器降噪装置上表面焊接，将SK-12变压器降噪装置下表面与地面基础预埋槽钢焊接。</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">4、安装结束后的顺序如下（从上往下）：</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">（1）配电变压器</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">（2）配电变压器基础槽钢</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">（3）SK-12变压器降噪装置</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">（4）地面基础预埋槽钢</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <br/>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <img src="./static/images/byjz/变压器降噪-03.png"/>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <br/>\n' +
            '</p>\n' +
            '<table class="no-border">\n' +
            '    <tbody>\n' +
            '        <tr class="firstRow uniform-height">\n' +
            '            <td width="190" valign="top">\n' +
            '                <img src="./static/images/byjz/变压器降噪-04.png"/>\n' +
            '            </td>\n' +
            '            <td width="190" valign="top">\n' +
            '                <img src="./static/images/byjz/变压器降噪-05.png"/>\n' +
            '            </td>\n' +
            '            <td width="190" valign="top">\n' +
            '                <img src="./static/images/byjz/变压器降噪-06.png"/>\n' +
            '            </td>\n' +
            '            <td width="190" valign="top">\n' +
            '                <img src="./static/images/byjz/变压器降噪-07.png"/>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '    </tbody>\n' +
            '</table>\n' +
            '<p>\n' +
            '    <br/>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <br/>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-size: 16px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">居配电站降噪设计建议</span></strong><span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);"> </span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">1、将SK-12作为变压器的标准配套设施</span></strong><span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">配电变压器运行一定年限后，由于制造、安装、使用上的原因，总会产生一定噪声。如果等到发现配电变压器噪声扰&nbsp;人再进行整改，重新改造的费用将是当初一次性投入的数倍，而且改造过程必须停电，这也将影响供电可靠性，损失&nbsp;负荷，并且引起客户抱怨。所以，在新建时将SK-12作为变压器的配套设施一同建设，就能以非常低的成本，就使整&nbsp;个变压器运行寿命期内，都无须处理因变压器噪声而引起的问题。目前，将SK-12变压器降噪装置作为环保配套设施&nbsp;一同建设，已经是很多城市的标准设计。</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">2、变压器出线采用软连接</span></strong><span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">配电变压器噪声的结构传递，除了通过地面传递到整个建筑物构架的途径，还有一个可能的途径是通过连接配电变压&nbsp;器的出线。如果该出线采用铜排等硬连接，变压器噪声同样可以通过铜排、固定铜排的构架传递到建筑物构架。因此，&nbsp;要根治变压器噪声传递途径，变压器出线必须采用软连接。</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">3、居配电站采用封闭设计，通过低噪音风机降温和通风</span></strong><span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">变压器噪声的传递，除了结构传递，还有空气传递；在封闭的居配电站里，噪声就无法通过居配电站的门、窗传递出&nbsp;去，完全隔绝噪声的所有传递途径。居配电站的通风降温，可以通过配置低噪音轴流风机解决，对噪声要求特别高的&nbsp;区域，可以选装风机消音器。</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">对居配电站的具体通风降温降噪设计，可以咨询我们的工程师。</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">4、室内消音处理</span></strong><span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">&nbsp;</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">由于主变运行时会有低频噪音，因此在室内需要布置吸音材料，以吸收主变散发的噪音。吸音材料主要采用1mm&nbsp;厚的岩棉吸音板，消声墙板总厚为80mm，墙板为双层结构，中间采用岩棉吸音。从骨架到面板全部采用金属材料</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">制成，能耐高温和气流（或风力）的冲击，耐潮湿，即便空气中含有大量的水份，也能照常工作。吸声性能优良，&nbsp;防火、防潮、不变形、不改性、不霉烂、无毒无味安装效果如下：</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <br/>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <strong><span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">YNEN-XY50 &nbsp;&nbsp;&nbsp;高级墙面吸音板</span></strong>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <br/>\n' +
            '</p>\n' +
            '<table class="no-border">\n' +
            '    <tbody>\n' +
            '        <tr class="firstRow">\n' +
            '            <td width="401" valign="top">\n' +
            '                <img src="./static/images/byjz/变压器降噪-08.png"/>\n' +
            '            </td>\n' +
            '            <td width="401" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">由于主变运行时会有低频噪音，因此在室内需要布置吸音材料，以吸收主变散 发的噪音。吸音板表面采用1mm铝板，根据声学降噪原理冲制一定规则的吸 收孔，内衬环保吸音材料。从骨架到面板全部采用金属材料制成，能耐高温和 气流（或风力）的冲击，耐潮湿，即便空气中含有大量的水份，也能照常工作。 吸声性能优良，防火、防潮、不变形、不改性、不霉烂、无毒无味</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">厚度：80mm&nbsp;</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-size: 16px;line-height:1.8; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(63, 63, 63);">降噪：6-8dB</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '    </tbody>\n' +
            '</table>\n' +
            '<p>\n' +
            '    <br/>\n' +
            '</p>',
          'parameter':'<table data-sort="sortDisabled">\n' +
            '    <tbody>\n' +
            '        <tr class="firstRow">\n' +
            '            <td width="252" valign="middle" style="word-break: break-all;" rowspan="5" colspan="1" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">变压降噪装置</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">YNEN-CS3</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">适用范围</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">10~335kV变压器</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">外形尺寸</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1500 x 350 x 170mm<sup>3</sup></span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-size: 14px; font-family: 微软雅黑, &#39;Microsoft YaHei&#39;;">（长 x 宽 x 厚，单块，可定制）</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">额定载重</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1000~10000kg</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">降噪频率</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">50~500Hz</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">降噪比率</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">99%</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '    </tbody>\n' +
            '</table>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">（说明：产品需根据变压器型号、底座定制、参数仅供参考）</span>\n' +
            '</p>',
          'download':''
        },
        {
          'id': 'g-1',
          'name': '智能低噪音风机',
          'path': './static/images/znfj/znfj-1.png',
          'model':'NDF系列',
          'useFor':'SF6开关室、变压器室、电容器室、地下室等需要通风场合，尤其是对运行噪音有要求的地区。',
          'imgList':['./static/images/znfj/znfj-1.png','./static/images/znfj/znfj-2.png','./static/images/znfj/znfj-3.png'],
          'overview':
            '<p style="margin-top:1px">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px;">&nbsp;</span>\n' +
            '</p>\n' +
            '<p style="margin-right: 0;margin-left: 8px">\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(65, 64, 66); font-size: 16px;">产品特点：</span></strong>\n' +
            '</p>\n' +
            '<p style="margin-right: 0;margin-left: 8px">\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(65, 64, 66); font-size: 16px;"><br/></span></strong>\n' +
            '</p>\n' +
            '<p style="margin-top: 6px;margin-right: 0;margin-left: 8px">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(65, 64, 66); font-size: 16px;">1、风机本体、防护罩、出风百页等一体化设计，安全、美观</span>\n' +
            '</p>\n' +
            '<p style="margin-top: 6px;margin-right: 0;margin-left: 8px">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(65, 64, 66); font-size: 16px;">2、出风百页薄型设计，紧贴墙面，视觉效果更好</span>\n' +
            '</p>\n' +
            '<p style="margin-top: 6px;margin-right: 0;margin-left: 8px">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; line-height: 135%; text-align: justify; color: rgb(65, 64, 66);">4、多项结构设计，充分考虑客户安全和功能要求</span><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; line-height: 135%; text-align: justify; color: rgb(65, 64, 66); letter-spacing: 2px;">&nbsp;</span>\n' +
            '</p>\n' +
            '<p style="margin-top:6px;margin-right:371px;margin-left:29px;text-align:justify;text-justify:inter-ideograph;line-height:135%">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(65, 64, 66); font-size: 16px;">a)&nbsp;<span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(65, 64, 66);">可伸缩的网罩支架，适合不同墙壁厚度使用</span>&nbsp;</span>\n' +
            '</p>\n' +
            '<p style="margin-top:6px;margin-right:371px;margin-left:29px;text-align:justify;text-justify:inter-ideograph;line-height:135%">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(65, 64, 66); font-size: 16px;">b)&nbsp;多重隔雨措施，可以防止雨水灌入室内</span>\n' +
            '</p>\n' +
            '<p style="margin-top: 2px;margin-right: 381px;margin-left: 29px;line-height: 135%">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(65, 64, 66); font-size: 16px;">d)&nbsp;内置式滤网，防止昆虫进入</span>\n' +
            '</p>\n' +
            '<p style="margin-top: 2px;margin-right: 0;margin-left: 29px">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(65, 64, 66); font-size: 16px;">e) &nbsp;出风百页内置连杆，不会产生页片碰撞噪音</span>\n' +
            '</p>\n' +
            '<p style="margin-top:1px">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px;">&nbsp;</span>\n' +
            '</p>\n' +
            '<p style="margin-right: 134px;margin-left: 8px;line-height: 17px">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px;"><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(65, 64, 66);">本产品符合GB/T 13274-91一般用途轴流通风机技术条件。</span><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(65, 64, 66); letter-spacing: -2px;">&nbsp;</span><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(65, 64, 66);">本产品外观结构已经申请国家专利。</span></span>\n' +
            '</p>\n' +
            '<p style="margin-right: 134px;margin-left: 8px;line-height: 17px">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px;"><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(65, 64, 66);"><br/></span></span>\n' +
            '</p>\n' +
            '<p style="margin-right: 134px; margin-left: 8px; line-height: 17px;">\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px;"><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(65, 64, 66);">型号说明：</span></span></strong>\n' +
            '</p>'+
            '<p>\n' +
            '    <img style="width: 80%" src="./static/images/znfj/znfj-4.png"/>\n' +
            '</p>\n'
          ,
          'parameter':'<table>\n' +
            '    <tbody>\n' +
            '        <tr class="firstRow">\n' +
            '            <td width="115" valign="top" style="word-break: break-all;">\n' +
            '                <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">型号</span></strong>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <p>\n' +
            '                    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">主轴转速</span></strong>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">r/min</span></strong>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <p>\n' +
            '                    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">风量</span></strong>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">m<sup>3</sup>/h</span></strong>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <p>\n' +
            '                    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">全压</span></strong>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">Pa</span></strong>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <p>\n' +
            '                    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">噪声</span></strong>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">dB（A）</span></strong>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <p>\n' +
            '                    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">功率</span></strong>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">kW</span></strong>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-3F/ZS</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1450</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">2267</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">60.6</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">41</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0.06</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-3F/ZSG</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">2900</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">4285</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">242.5</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">53</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0.55</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-4F/ZS</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">960</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">3427</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">47.2</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">40</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0.18</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-4F/ZSG</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1450</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">4959</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">107.7</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">47</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0.25</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-5F/ZS</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">960</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">6635</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">73.7</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">43</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0.37</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-5F/ZSG</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1450</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">9752</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">168.2</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">54</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0.75</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-6F/ZS</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">720</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">11390</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">106.2</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">49</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0.75</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-6F/ZSG</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">960</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">17200</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">242.3</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">58</span>\n' +
            '            </td>\n' +
            '            <td width="115" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">2.2</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-7F/ZS</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">720</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">14320</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">81.3</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">50</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">0.75</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-7F/ZSG</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">960</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">18560</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">14.5</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">54</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1.5</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-8F/ZS</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">710</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">21525</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">106.2</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">52</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1.1</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-8F/ZSG</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">960</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">27520</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">188.8</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">57</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">3</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-9F/ZS</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">720</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">29500</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">134.4</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">56</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">2.2</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-9F/ZSG</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">960</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">38250</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">239.0</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">60</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">4</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-10F/ZS</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">720</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">39520</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">166</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">58</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">3</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '    </tbody>\n' +
            '</table>\n' +
            '<p>\n' +
            '    <br/>\n' +
            '</p>\n' +
            '<table>\n' +
            '    <tbody>\n' +
            '        <tr class="firstRow">\n' +
            '            <td width="90" valign="top" style="word-break: break-all;">\n' +
            '                <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">型号</span></strong>\n' +
            '            </td>\n' +
            '            <td width="50" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">a</span></strong>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">b</span></strong>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">c</span></strong>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">d</span></strong>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">e</span></strong>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">A</span></strong>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">B</span></strong>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">H</span></strong>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="90" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-3F/ZS</span>\n' +
            '            </td>\n' +
            '            <td width="50" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">380</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">320</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">35</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">20</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">244</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">230-285</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">280-335</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">400</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="90" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-3F/ZSG</span>\n' +
            '            </td>\n' +
            '            <td width="50" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">380</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">320</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">35</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">20</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">244</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">230-285</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">280-335</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">400</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="90" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-4F/ZS</span>\n' +
            '            </td>\n' +
            '            <td width="50" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">480</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">420</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">40</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">20</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">244</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">225-285</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">275-335</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">500</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="90" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-4F/ZSG</span>\n' +
            '            </td>\n' +
            '            <td width="50" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">480</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">420</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">40</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">20</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">244</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">225-285</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">275-335</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">500</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="90" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-5F/ZS</span>\n' +
            '            </td>\n' +
            '            <td width="50" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">580</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">520</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">40</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">20</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">244</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">228-285</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">275-335</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">600</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="90" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-5F/ZSG</span>\n' +
            '            </td>\n' +
            '            <td width="50" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">580</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">52</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">40</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">20</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">244</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">225-285</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">275-335</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">600</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="90" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-6F/ZS</span>\n' +
            '            </td>\n' +
            '            <td width="50" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">680</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">620</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">50</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">20</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">290</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">260-330</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">310-380</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">700</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="90" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-6F/ZSG</span>\n' +
            '            </td>\n' +
            '            <td width="50" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">680</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">620</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">50</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">20</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">290</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">260-330</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">310-380</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">700</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-7F/ZS</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">790</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">720</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">60</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">30</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">330</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">330-370</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">350-420</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">800</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-7F/ZSG</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">790</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">720</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">60</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">30</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">330</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">330-370</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">350-420</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">800</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-8F/ZS</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">890</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">820</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">60</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">30</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">370</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">340-410</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">390-460</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">920</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-8F/ZSG</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">890</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">820</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">60</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">30</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">370</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">340-410</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">390-460</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">920</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-9F/ZS</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1000</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">925</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">70</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">30</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">390</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">350-440</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">440-490</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1100</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-9F/ZSG</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1000</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">925</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">70</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">30</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">390</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">350-440</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">440-490</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1100</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="90" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">NDF-10F/ZS</span>\n' +
            '            </td>\n' +
            '            <td width="50" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1120</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1030</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">70</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">30</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">420</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">380-470</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">430-520</span>\n' +
            '            </td>\n' +
            '            <td width="70" valign="top" style="word-break: break-all;" align="center">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">1200</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '    </tbody>\n' +
            '</table>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">注： &nbsp; A为风机百叶窗外置时适合墙面厚度，可根据要求定制；</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp;B为风机百叶窗内置时时候墙面厚度，可根据要求定制；</span>\n' +
            '</p>\n' +
            '<p>\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp;H为墙面预留正方形孔边长</span><br/>\n' +
            '</p>',
          'download':''
        },
        {
          'id': 'h-1',
          'name': '连接点测温系统',
          'path': './static/images/ctcw/测温触头-03.png',
          'model':'ES-9000T',
          'imgList':['./static/images/ctcw/测温触头-03.png'],
          'overview':
            '<p style="margin-top: 1px;margin-left: 8px;line-height: 135%">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px;"><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(65, 64, 66); letter-spacing: 0px;">电气设备连接点，如断路器触头、刀闸触头、母排连接 点、电缆连接点、线路连接点等，由于制造质量或运行</span><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(65, 64, 66); letter-spacing: -2px;">&nbsp;</span><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(65, 64, 66); letter-spacing: 0px;">维护的问题，经常会出现连接可靠性故障，连接点温度</span><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(65, 64, 66); letter-spacing: -2px;">&nbsp;</span><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(65, 64, 66); letter-spacing: 0px;">大幅上升，造成设备损毁。在所有设备故障中，连接点 故障一般占比高达80~90%，是电气设备运行中最容易 出现的设备故障类型。为保证供电可靠性，提前发现设 备运行隐患，对设备连接点进行温度监测，已经成为电 气技术人员的共识。&nbsp;</span></span>\n' +
            '</p>\n' +
            '<p style="margin-top: 1px;margin-left: 8px;line-height: 135%">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(65, 64, 66); letter-spacing: 0px; font-size: 16px;">为保证供电可靠性，提前发现设备运行隐患，对设备连 接点进行温度监测，已经成为电气技术人员的共识。</span>\n' +
            '</p>\n' +
            '<p style="margin-top:0">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px;">&nbsp;</span>\n' +
            '</p>\n' +
            '<p style=";margin-left: 8px;line-height: 135%">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;;"><span style="font-size: 16px; color: rgb(65, 64, 66); letter-spacing: 0px;">ES-9000T连接点测温系统以先进的电压感应取电技术</span><span style="font-size: 16px;"><span style="font-size: 16px; color: rgb(65, 64, 66); letter-spacing: 0px;">作为基础，开发了无源无线系列连接点测温系统。它独</span><span style="font-size: 12px; color: rgb(65, 64, 66); letter-spacing: -3px;">&nbsp;</span><span style="font-size: 12px; color: rgb(65, 64, 66); letter-spacing: 0px;"><span style="font-size: 16px;">有的电压感应技术，可以直接利用空间电场感应的微弱</span> <span style="font-size: 16px;">电势。独特的超低功耗电路设计技术，可以同时为温度</span> <span style="font-size: 16px;">监测和数据通信单元提供能量。</span></span></span></span>\n' +
            '</p>\n' +
            '<p style=";margin-left: 8px;line-height: 135%">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(65, 64, 66); letter-spacing: 0px;"><br/></span>\n' +
            '</p>\n' +
            '<p style=";margin-left: 8px;line-height: 135%">\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(65, 64, 66); letter-spacing: 0px;">产品特点：</span></strong>\n' +
            '</p>\n' +
            '<p style=";margin-left: 8px;line-height: 135%">\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(65, 64, 66); letter-spacing: 0px;"><br/></span></strong>\n' +
            '</p>\n' +
            '<p style=";margin-left: 8px;line-height: 135%">\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(65, 64, 66); letter-spacing: 0px;"></span></strong>\n' +
            '</p>\n' +
            '<p style="margin-top: 1px;margin-left: 8px;line-height: 133%">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px;"><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; line-height: 133%; color: rgb(48, 74, 159); letter-spacing: 1px;">电压感应取电技术 </span><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(65, 64, 66); letter-spacing: 0px;">安装在高压设备上的测温变送器，可以直接取用空间电 场的微弱电势，为变送器提供能量。</span></span>\n' +
            '</p>\n' +
            '<p style="margin-top: 7px;margin-left: 8px;text-indent: 0;line-height: 133%">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px;"><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; line-height: 133%; color: rgb(48, 74, 159); letter-spacing: 1px;">超低功耗电路设计技术 </span><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; line-height: 133%; color: rgb(65, 64, 66); letter-spacing: 0px;">电压感应的微弱电量，不仅为高精度温度传感器提供能 量，还能不可思议地地支持无线通信。</span></span>\n' +
            '</p>\n' +
            '<p style="margin-top: 7px;margin-left: 8px;line-height: 133%">\n' +
            '    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px;"><span style="font-size: 13px; line-height: 133%; color: rgb(48, 74, 159); letter-spacing: 1px;"><span style="font-size: 16px;">超长运行时间</span> </span><span style="font-size: 12px; color: rgb(65, 64, 66); letter-spacing: 0px;"><span style="font-size: 16px;">等电位设计，无惧浪涌冲击；军品级器件，设计运行时</span> <span style="font-size: 16px;">间高达</span><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; color: rgb(65, 64, 66); letter-spacing: 0px;">20年</span>。</span></span>\n' +
            '</p>\n' +
            '<p style="margin-top: 7px;margin-left: 8px;line-height: 133%">\n' +
            '    <span style="font-family: 方正黑体_GBK; color: rgb(48, 74, 159); font-size: 19px; text-align: right;"><br/></span>\n' +
            '</p>\n' +
            '<p style="margin-top: 7px;margin-left: 8px;line-height: 133%">\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px;"><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; color: rgb(48, 74, 159); text-align: right;">开关柜连接点测温</span><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; text-align: right; color: rgb(88, 89, 91);">|铜排</span></span></strong>\n' +
            '</p>\n' +
            '<p style="margin-top: 7px;margin-left: 8px;line-height: 133%">\n' +
            '    <strong><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px;"><span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; text-align: right; color: rgb(88, 89, 91);"><br/></span></span></strong>\n' +
            '</p>\n' +
            '<ul class=" list-paddingleft-2" style="list-style-type: disc;">\n' +
            '    <li>\n' +
            '        <p style="margin-top: 7px;margin-left: 8px;line-height: 133%">\n' +
            '            <span style="color: rgb(65, 64, 66); font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; letter-spacing: 0px; text-align: right;">铜排、及其他平面测温</span>\n' +
            '        </p>\n' +
            '    </li>\n' +
            '    <li>\n' +
            '        <p style="margin-top: 7px;margin-left: 8px;line-height: 133%">\n' +
            '            <span style="color: rgb(65, 64, 66); font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 16px; letter-spacing: 0px; line-height: 133%;">安装在与断路器静触头相连的铜排上，可以监测断路器触头温</span>\n' +
            '        </p>\n' +
            '    </li>\n' +
            '</ul>\n' +
            '<p style="margin-left: 8px; line-height: 135%;"></p>'+
            '<p>\n' +
            '    <img style="width: 80%" src="./static/images/ctcw/测温触头-04.png"/>\n' +
            '</p>\n'
          ,
          'parameter':'<table data-sort="sortDisabled">\n' +
            '    <tbody>\n' +
            '        <tr class="firstRow">\n' +
            '            <td width="252" valign="middle" style="word-break: break-all;" rowspan="7" colspan="1" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">测温传感器</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">ES-9000T10P</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">工作电源</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">电压感应取电</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">适用电压</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">6kV~10kV</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">测温误差</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">±1℃</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">采样频率</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">＜180秒</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">工作范围</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">-50~150℃</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">测温范围</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">-40~150℃（ES-9000T10P）</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">-40~300℃（ES-9000T10PW）</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">外形尺寸</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">54 x 20.5 x 28mm<sup>3</sup>（不含天线板）</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">100 x 70 x 29mm<sup style="white-space: normal;">3</sup>（含天线板）</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="middle" colspan="1" rowspan="3" style="word-break: break-all;" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">测温数据采集器</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">ES-9000TL</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">工作电源</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">AC220V</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">通信方式</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">RS485、无线通信</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">出厂编码</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">固定地址</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="middle" style="word-break: break-all;" rowspan="4" colspan="1" align="left">\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">测温数据终端</span>\n' +
            '                </p>\n' +
            '                <p>\n' +
            '                    <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">ES-9000T</span>\n' +
            '                </p>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">工作电源</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">AC100~240V</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">显示器</span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">7寸TFT</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">按键方式</span>\n' +
            '            </td>\n' +
            '            <td valign="top" colspan="1" rowspan="1" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">触摸屏</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '        <tr>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">通信方式<br/></span>\n' +
            '            </td>\n' +
            '            <td width="252" valign="top" style="word-break: break-all;">\n' +
            '                <span style="font-family: 微软雅黑, &#39;Microsoft YaHei&#39;; font-size: 14px;">无线通信</span>\n' +
            '            </td>\n' +
            '        </tr>\n' +
            '    </tbody>\n' +
            '</table>\n' +
            '<p>\n' +
            '    <br/>\n' +
            '</p>',
          'download':''
        }
      ]
    },
  ]
};



// WEBPACK FOOTER //
// ./src/assets/data/goods-list.js